import api from './api';

class CategoryService {
    async getCategories() {
        return api.get('products/categories/');
    }
}

export default new CategoryService();
